export const getLocalCurrentUnit = () => JSON.parse(localStorage.getItem('CurrentUnit'))
export const deleteLocalCurrentUnit = () => localStorage.removeItem('CurrentUnit')
export const setLocalCurrentUnit = unit => localStorage.setItem('CurrentUnit', JSON.stringify(unit))